document.addEventListener('DOMContentLoaded', function() {
    var subNav = document.querySelector('.sub-nav');
    if (!subNav) return;

    function positionDropdown(item) {
        var dropdown = item.querySelector('.sub-nav__dropdown');
        if (!dropdown) return;
        var rect = item.getBoundingClientRect();
        dropdown.style.top  = rect.bottom + 'px';
        dropdown.style.left = window.innerWidth < 768 ? '0px' : rect.left + 'px';
    }

    // Position dropdown after submenu-open.js has toggled the open class
    subNav.addEventListener('click', function(e) {
        var toggle = e.target.closest('.icon-chevron-top, .sub-nav__item--hash-link > .sub-nav__item-inner > a');
        if (!toggle) return;
        var item = toggle.closest('.sub-nav__item');
        if (!item) return;
        // submenu-open.js has already toggled the class at this point
        if (item.classList.contains('open')) {
            positionDropdown(item);
        }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.sub-nav')) {
            subNav.querySelectorAll('.sub-nav__item.open').forEach(function(item) {
                item.classList.remove('open');
            });
        }
    });

    // Close on scroll so fixed dropdown doesn't drift
    window.addEventListener('scroll', function() {
        subNav.querySelectorAll('.sub-nav__item.open').forEach(function(item) {
            item.classList.remove('open');
        });
    }, { passive: true });
});

//# sourceMappingURL=sub-nav.js.map
